import { useState } from 'react';
import { EditConfig } from './table-utils';

/**
 * Hook that manages row-level inline editing state.
 * Returns state + actions + an EditConfig object to pass to buildColumnDefinitions.
 */
export function useEditableRow() {
    const [editingId, setEditingId] = useState<string | null>(null);
    const [editValues, setEditValues] = useState<Record<string, any>>({});
    const [isAddingNew, setIsAddingNew] = useState(false);

    const startEdit = (id: string, currentValues: Record<string, any>) => {
        setEditingId(id);
        setEditValues(currentValues);
        setIsAddingNew(false);
    };

    const startNew = (defaults: Record<string, any> = {}) => {
        setEditingId('__new__');
        setEditValues(defaults);
        setIsAddingNew(true);
    };

    const cancel = () => {
        setEditingId(null);
        setEditValues({});
        setIsAddingNew(false);
    };

    const setValue = (fieldId: string, value: any) => {
        setEditValues(prev => ({ ...prev, [fieldId]: value }));
    };

    /** Pass this to buildColumnDefinitions as the 3rd argument */
    const editConfig: EditConfig = {
        editingId,
        editValues,
        onChange: setValue,
    };

    return {
        editingId,
        editValues,
        isAddingNew,
        editConfig,
        actions: { startEdit, startNew, cancel, setValue },
    };
}
